// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xRC7V","header":"styles_header__5d4GK","selection":"styles_selection__1dPa0","input":"styles_input__1dOYr","footer":"styles_footer__0CrpJ"};